import { Color, Spacing } from '@persona-id/design-tokens';
import { XIcon } from '@persona-id/design-tokens/icons';
import { kebabCase } from 'lodash/fp';
import { BORDER_RADIUSES } from 'shared/styles/variables';
import styled from 'styled-components';

import Button from 'design-system/components/Button';

const HandlebarPillWrapper = styled.span`
  position: relative;
`;

const HandlebarValue = styled.span<{ error: boolean }>`
  color: ${Color.PrimaryWhite};
  background-color: ${({ error }) => (error ? Color.CoreRed700 : Color.CorePurple500)};
  border-radius: ${BORDER_RADIUSES.rounded};
  padding: 2px 0;

  &:before {
    content: '{{';
    color: transparent;
  }
  &:after {
    content: '}}';
    color: transparent;
  }
`;

const StyledButton = styled(Button)`
  position: absolute;
  bottom: ${Spacing[3]};
  right: -${Spacing[1]};
  padding: 2px;
  height: 12px;
  width: 12px;
  border-radius: 6px;
  pointer-events: auto;
`;

interface HandlebarPillProps {
  value: string;
  error: boolean;
  onDelete?: () => void;
}

const HandlebarPill = ({ value, error, onDelete }: HandlebarPillProps) => (
  <HandlebarPillWrapper>
    <HandlebarValue error={error} aria-label={`${error ? 'an invalid' : 'a valid'} handlebar`}>
      {value}
    </HandlebarValue>
    {onDelete && (
      <StyledButton
        aria-label={`Delete ${value}`}
        id={`handlebar-pill__button-${kebabCase(value)}`}
        variant='basic'
        onClick={onDelete}
      >
        <XIcon />
      </StyledButton>
    )}
  </HandlebarPillWrapper>
);

export default HandlebarPill;
